"use client";

import SentryErrorComponent from "@stadium/services/error-reporting/app/error";

import ErrorComponent from "@components/error";

export default function GlobalError({ error }) {
  return <SentryErrorComponent error={error} ErrorComponent={ErrorComponent} />;
}
